export default class CheckFieldUtil {
    static customer(column) {
        let accessorKey = column.id;
        return !(accessorKey === 'id'  || accessorKey === 'enabled');
    }
    static worker(column) {
        let accessorKey = column.id;
        return !(accessorKey === 'id'  || accessorKey === 'enabled'|| accessorKey === 'production'|| accessorKey === 'constructor');
    }
}